import countryData from 'flag-icons/country.json';

export interface Country {
  code : string; // code ISO 3166-1 alpha-2 en minuscules (utilisé par flag-icons, ex: "fr")
  name : string; // nom du pays en français
}

// Intl.DisplayNames rend certains noms avec une apostrophe typographique (’) ; on la
// normalise en apostrophe droite (') pour rester cohérent avec les valeurs déjà
// enregistrées en base (ex: anciens comptes ayant "Côte d'Ivoire").
const regionNames = new Intl.DisplayNames(['fr'], { type: 'region' });
const toFrenchName = (isoCode: string): string =>
  (regionNames.of(isoCode.toUpperCase()) || isoCode).replace(/’/g, "'");

export const COUNTRY_LIST: Country[] = countryData
  .filter((country) => country.iso)
  .map((country) => ({ code: country.code, name: toFrenchName(country.code) }))
  .sort((a, b) => a.name.localeCompare(b.name, 'fr'));

// Conservé pour les comptes existants dont le pays est déjà enregistré comme "Autre".
export const COUNTRY_OTHER: Country = { code: '', name: 'Autre' };
